<template>
  <div class="shop-menu" :class="{ 'is-app': isApp }">
    <app-loader v-if="!hasMenu || !isInited" />
    <template v-if="isInited">
      <menu-swiper-app
        v-if="isApp"
        ref="menuSwiperApp"
        :active-category-index="activeCategoryIndex"
      />
      <menu-swiper-web v-else ref="menuSwiperWeb" :active-category-index="activeCategoryIndex" />
    </template>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import AppLoader from '@/components/loader/AppLoader'
import MenuSwiperApp from '@/components/swiper/MenuSwiperApp'
import MenuSwiperWeb from '@/components/swiper/MenuSwiperWeb'

export default {
  components: {
    AppLoader,
    MenuSwiperApp,
    MenuSwiperWeb,
  },
  data() {
    return {
      isInited: false,
    }
  },
  computed: {
    ...mapGetters({
      menuList: 'menu/getMenu',
      hasMenu: 'menu/getHasMenu',
      activeCategoryIndex: 'menu/getActiveCategoryIndex',
      language: 'setting/getLanguage',
    }),
    isApp() {
      return process.env.VUE_APP_TYPE === 'app'
    },
  },
  watch: {
    menuList() {
      // MenuSwiperのリセットのための
      this.isInited = false
      this.$nextTick(() => {
        this.isInited = true
      })
    },
    language() {
      this.$emit('updateHead')
    },
  },
  mounted() {
    if (this.hasMenu) {
      this.isInited = true
      this.fetchMenu()
    }
  },
  methods: {
    ...mapActions({
      fetchMenu: 'menu/fetchMenu',
    }),
  },
  beforeRouteLeave(to, from, next) {
    if (this.isApp) {
      // 現在のslideのscroll位置を記憶
      this.$refs.menuSwiperApp.saveScrollPosition('current')
    } else {
      // 現在のページのscroll位置を記憶
      this.$refs.menuSwiperWeb.saveScrollPosition()
    }
    next()
  },
  head: {
    title() {
      return {
        inner: this.$t(`pageTitle.${this.$route.name}`),
        complement: this.$t('siteId'),
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.shop-menu {
  position: relative;
  background-color: #fff;
  box-sizing: border-box;

  &.is-app {
    height: calc(100vh - 105px);
  }
}
</style>
